define('TrackingSO.PDP.View', [
    'Backbone',
    'empty.tpl'
], function (
    Backbone,
    emptyTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: emptyTpl,

        initialize: function (options) {
            var self = this;
            var urlParams = new URLSearchParams(window.location.search);
            var adParam = urlParams.get('ad');

            // Clear expired ad data
            self.clearExpiredAd();

            if (adParam) {
                var adData = {
                    value: adParam,
                    timestamp: Date.now()
                };
                localStorage.setItem('ad', JSON.stringify(adData));
            }
        },

        clearExpiredAd: function () {
            var expirationTimeMinutes = (this.options.trackingSOConfiguration && this.options.trackingSOConfiguration.expirationTimeMinutes) || 20;
            var EXPIRATION_TIME = expirationTimeMinutes * 60 * 1000; // Convert minutes to milliseconds
            var adStored = localStorage.getItem('ad');

            if (adStored) {
                try {
                    var adData = JSON.parse(adStored);
                    if (adData.timestamp && (Date.now() - adData.timestamp > EXPIRATION_TIME)) {
                        localStorage.removeItem('ad');
                    }
                } catch (e) {
                    // If it's not valid JSON (old format), remove it
                    localStorage.removeItem('ad');
                }
            }
        },


        getContext: function () {
            return {
            };
        }
    });
});
